'use client';

const MainErrorKD = () => (
  <div className="background-kd min-h-[calc(100vh-380px)] flex items-center max-md:py-10 md:py-20">
    <div className="container px-4 w-full">
      <p className="text-sm font-semibold text-kd-athens-gray tracking-wider">ERROR 500</p>
      <h1 className="mt-5 max-md:text-3xl md:text-4xl font-bold text-white">
        Something broke on our end
      </h1>
      <p className="text-white mt-2 max-w-140">
        The page didn&apos;t load because of a problem on our servers — not anything you did. Your
        search, your slots and your resume are safe
      </p>
      <button
        className="mt-7 flex items-center gap-2 w-fit font-bold text-kd-woodsmoke max-md:px-4 md:px-6 max-md:py-2 md:py-3 rounded-full default-transition bg-white hover:bg-kd-athens-gray"
        onClick={() => window.location.reload()}
      >
        Try again{' '}
        <span className="text-xl" aria-hidden="true">
          →
        </span>
      </button>
    </div>
  </div>
);

export default MainErrorKD;
